import React, { useState } from 'react';
import classnames from 'classnames';
import Card from 'reactstrap/lib/Card';
import { CmsEntities } from 'client/data/models/cms';
import { RadioList } from 'site-modules/shared/components/radio-list/radio-list';
import { ResearchEntry } from 'site-modules/editorial/components/about-article/research-entry/research-entry';

import './card-tabs.scss';

export function CardTabs({ entry }) {
  const children = entry.children();
  const [selectedTab, selectTab] = useState(children[0].id);

  function onChange({ currentTarget: { value } }) {
    selectTab(value);
  }

  const tabsList = children.map(childEntry => ({
    id: childEntry.id,
    title: childEntry.id,
    text: childEntry.metadata('tabName').value(),
    hideValue: true,
  }));

  return (
    <Card className="card-tabs d-block text-gray-darker px-1 px-md-1_5 py-1">
      <RadioList
        onChange={onChange}
        name="tabs-list"
        list={tabsList}
        checked={selectedTab}
        formClassName="mb-0 d-flex justify-content-between d-sm-block"
        formGroupClassName="me-sm-2 d-inline-block"
        labelContainerClassName="p-0"
        textClassName="tab-label py-0_5 size-20"
        checkmarkClassName="d-none"
      />
      <div className="mt-1_5">
        {children.map(childEntry => (
          <div key={childEntry.id} className={classnames({ 'd-none': selectedTab !== childEntry.id })}>
            <ResearchEntry entry={childEntry} />
          </div>
        ))}
      </div>
    </Card>
  );
}

CardTabs.propTypes = {
  entry: CmsEntities.Content.isRequired,
};
